export const parseSalary = (value) => {
  return parseFloat(value.split(",").join("")) || 0;
};
